import { withFeatureBranch } from '../redux/flags';
import { default as FolderCard } from './FolderCard';
import { default as FolderCardV2 } from '../FolderCardV2';
export default withFeatureBranch({
    folder_grid: FolderCardV2,
})(FolderCard);
//# sourceMappingURL=index.js.map